import type { recurringFeeType_enum } from '@vrplatform/graphql';
import type { FeeFormInputs } from '../edit/useFeeForm';

const DEFAULT_FORMULA = '(accounts) * "rate"';

export const FEE_TEMPLATES: Record<
  recurringFeeType_enum,
  {
    formInputs: FeeFormInputs;
    config: {
      accounts: string[];
      formulaTemplate: string;
    };
  }
> = {
  managementFee: {
    formInputs: {
      creditAccountId: 'Management Commission Revenue', // '4160',
      debitAccountId: 'Management Commission Expense', // '5000',
      creditParty: 'manager',
      debitParty: 'owners',
      id: undefined,
      title: 'Management Commission',
      revenueRecognition: 'checkIn',
      type: 'managementFee',
      bookingChannelsFilter: 'all-channels',
      statusFilter: null,
      accountTotalConditions: null,
      taxRateId: null,
      taxRateBehavior: 'excluded',
      rate: 20000,
      linkedAccountIds: [],
    },
    config: {
      // accounts: ['4000', '4020', '5010', '5020'],
      accounts: [
        'Rents',
        'Cancellation Fees',
        'Channel Commissions',
        'Merchant Fees',
      ],
      formulaTemplate: DEFAULT_FORMULA,
    },
  },
  merchantFee: {
    // STRIPE
    formInputs: {
      creditAccountId: 'Processing Fees', // '4110',
      debitAccountId: 'Merchant Fees', // '5020',
      creditParty: 'manager',
      debitParty: 'owners',
      id: undefined,
      title: 'Merchant Fees',
      revenueRecognition: 'checkIn',
      type: 'merchantFee',
      bookingChannelsFilter: [],
      statusFilter: null,
      accountTotalConditions: null,
      taxRateId: null,
      taxRateBehavior: 'excluded',
      rate: 100000,
      linkedAccountIds: [],
    },
    config: {
      // accounts: ['5020'],
      accounts: ['Merchant Fees'],
      formulaTemplate: `-(accounts) * "rate"`,
    },
  },
  bookingChannelFee: {
    // BOOKING.COM
    formInputs: {
      creditAccountId: 'Booking Fees', // '4040',
      debitAccountId: 'Channel Commissions', // '5010',
      creditParty: 'manager',
      debitParty: 'owners',
      id: undefined,
      title: 'Booking Channel Fee',
      revenueRecognition: 'checkIn',
      type: 'bookingChannelFee',
      bookingChannelsFilter: [],
      statusFilter: null,
      accountTotalConditions: null,
      taxRateId: null,
      taxRateBehavior: 'excluded',
      rate: 5000,
      linkedAccountIds: [],
    },
    config: {
      // accounts: ['4000', '4010'],
      accounts: ['Rents', 'Cleaning Fees'],
      formulaTemplate: DEFAULT_FORMULA,
    },
  },
  cleaningFee: {
    formInputs: {
      creditAccountId: 'Cleaning Fees', // '4010',
      debitAccountId: 'Cleaning Fees', // '4010',
      creditParty: 'manager',
      debitParty: 'owners',
      id: undefined,
      title: 'Cleaning Fee',
      revenueRecognition: 'checkIn',
      type: 'cleaningFee',
      bookingChannelsFilter: 'all-channels',
      statusFilter: null,
      accountTotalConditions: null,
      taxRateId: null,
      taxRateBehavior: 'excluded',
      rate: 100000,
      linkedAccountIds: [],
    },
    config: {
      // accounts: ['4010'],
      accounts: ['Cleaning Fees'],
      formulaTemplate: DEFAULT_FORMULA,
    },
  },
  additionalFee: {
    formInputs: {
      creditAccountId: 'create_new',
      debitAccountId: 'create_new',
      creditParty: 'manager',
      debitParty: 'owners',
      id: undefined,
      title: 'Custom Fee',
      revenueRecognition: 'checkIn',
      type: 'additionalFee',
      bookingChannelsFilter: 'all-channels',
      statusFilter: null,
      accountTotalConditions: null,
      taxRateId: null,
      taxRateBehavior: 'excluded',
      rate: 25000,
      linkedAccountIds: [],
    },
    config: {
      accounts: [],
      formulaTemplate: DEFAULT_FORMULA,
    },
  },
};
